import { properties } from '@Common/Core/Properties';
import pointerHelper from '@Common/Helpers/PointerHelper';
import { contextMenuItems, IContextMenuItem } from '@Common/Core/ContextMenuItems';
import { Popup } from '@Common/Controls/Popup';
import urlHelper from '@Common/Helpers/UrlHelper';

export type Coordinates = { x: number; y: number };
export type ContextMenuItem = { item: IContextMenuItem; checked?: boolean; disabled?: boolean };

export function ContextMenu(coordinates: Coordinates): ContextMenu {
    return contextMenu(coordinates);
}

export function contextMenu(coordinates: Coordinates): ContextMenu {
    let itemClick = _.noop;

    let root = null;
    let popup = null;

    let current;
    const children = [];

    function getItemIcon(item) {
        return !properties.isDesktopBrowser && item.mobileIcon ? item.mobileIcon : item.icon;
    }

    function removeChildren(currentLevel) {
        let i = children.length;

        while (i--) {
            if (i >= currentLevel) {
                children.pop().remove();
            }
        }
    }

    function remove() {
        removeChildren(0);
        popup.close();
        root.remove();
    }

    function createItems(level, parentId?, isTrellis?) {
        const container = $('<ul class="context-menu-list"/>');
        const result = $('<div class="context-menu popup-shadow"/>').append(container);

        const items = _(current)
            .filter(function (n) {
                return n.item.parentId == parentId && !n.disabled;
            })
            .value();

        _(items).forEach(function (i) {
            const hasChildren = _(current).some(function (n) {
                return n.item.parentId && n.item.parentId == i.item.id;
            });

            if (
                hasChildren &&
                !_(current).some(function (n) {
                    return n.item.parentId && n.item.parentId == i.item.id && !n.disabled;
                })
            ) {
                return result;
            }

            if (i.item.isSeparator) {
                return $('<li class="separator"></li>').appendTo(container);
            }

            const icon = $('<div class="icon"/>')
                .filter(function () {
                    return i.item.icon;
                })
                .css({
                    background: 'url(' + urlHelper.getImageUrl(getItemIcon(i.item)) + ') no-repeat scroll center center transparent',
                    backgroundSize: i.item.iconSize
                });

            const label = $('<div class="label"/>').text(i.item.name);

            const li = $('<li/>')
                .appendTo(container)
                .toggleClass('checked', i.checked == true)
                .toggleClass('has-children', hasChildren == true)
                .append(icon)
                .append(label)
                .filter(function () {
                    return !i.disabled;
                })
                .click(function (e) {
                    e.preventDefault();

                    if (!hasChildren) {
                        remove();
                        itemClick(i.item, i.checked, isTrellis);
                    }
                })
                .on(pointerHelper.pointerOverEventName, function () {
                    removeChildren(level);

                    if (hasChildren) {
                        const child = createItems(level + 1, i.item.id, isTrellis || i.item.id == contextMenuItems.trellis.id).appendTo(container);
                        children.push(child);

                        const windowWidth = $(window).width();
                        const windowHeight = $(window).height();

                        let diff = windowWidth - li.outerWidth(true) - li.offset().left - child.outerWidth(true);
                        const left =
                            diff >= 0 ? container.position().left + container.outerWidth() : container.position().left - child.outerWidth(true);
                        diff = windowHeight - li.offset().top - child.outerHeight(true);
                        const top = diff < 0 ? li.position().top + diff : li.position().top;

                        child.css('top', top).css('left', left);
                    }

                    container.find('li').removeClass('hover');
                    li.addClass('hover');
                })
                .end();

            return true;
        });

        return result;
    }

    function setValue(data) {
        if (!data.length) {
            return false;
        }

        current = data;

        root && root.empty();
        popup && popup.close();

        root = createItems(0);
        popup = new Popup({
            x: coordinates.x + 1, // To prevent hover on touch devices
            y: coordinates.y + 1,
            content: root,
            jointHeight: 0,
            reusable: false,
            resizableContent: false
        });

        return true;
    }

    return {
        setValue: setValue,
        itemClick: function (fn) {
            if ($.isFunction(fn)) {
                itemClick = fn;
            }
        },
        getControl: function () {
            return root;
        },
        remove: remove
    } as any;
}

interface ContextMenu {
    setValue(items: ContextMenuItem[]): void;

    itemClick(fn: (item: IContextMenuItem, checked: boolean, isTrellis: boolean) => void): void;
}
